const ProductModule = {
  namespaced: true,
  state: {
    data: [],
    products: []
  },
  mutations: {
    FETCH_MAINPAGE(state, payload) {
      state.data = payload
    },
    FETCH(state, payload) {
      state.data = []
      payload.ProductsTHA.forEach(element => {
        state.data.push({
          productid: element.productid,
          productname: element.productname,
          typeid: element.typeid,
          mainType: element.mainType
        })
      })
    },
    SEARCH(state, payload) {
      state.products = payload
    },
    DELETE: (state, payload) => {
      var index = state.data.findIndex(data => data.productid === payload)
      state.data.splice(index, 1)
    }
  },
  actions: {
    async fetchMainPage({ commit }) {
      try {
        const response = await axios.get(`/getProductMainPage`)
        commit('FETCH_MAINPAGE', response.data)
      } catch (error) {
        throw new Error(error)
      }
    },
    async fetch({ commit }) {
      try {
        const response = await axios.get(`/getProduct`)
        commit('FETCH', response.data)
      } catch (error) {
        throw new Error(error)
      }
    },
    async search({ commit }) {
      try {
        const response = await axios.get(`search/product`)
        commit('SEARCH', response.data)
      } catch (error) {
        throw new Error(error)
      }
    },
    async delete({ commit }, payload) {
      try {
        await axios.delete(`getProductBy/id/${payload}`)
        commit('DELETE', payload)
      } catch (error) {
        throw new Error(error)
      }
    }
  },
  getters: {
    getAll: state => {
      return state.data
    }
  }
}

export default ProductModule



// WEBPACK FOOTER //
// ./src/store/modules/product_module.js